import { SetterOrUpdater } from 'recoil'
import { EnhanceDraft } from './Threads'
import JelledModal from 'components/JelledModal'
import { TwinResponderEmail, TwinResponderThread } from 'api/model'

const EnhanceDraftModal = ({
  onClose,
  setIsEnhancingDraft,
  email,
  twinId,
  setThread,
  setVerboseOutput,
}: {
  onClose: () => void
  setIsEnhancingDraft: SetterOrUpdater<boolean>
  email: TwinResponderEmail
  twinId: string
  setThread: React.Dispatch<React.SetStateAction<TwinResponderThread | null>>
  setVerboseOutput: React.Dispatch<React.SetStateAction<string>>
}) => {
  return (
    <JelledModal onClose={onClose} isOpen={true}>
      <EnhanceDraft
        onClose={() => setIsEnhancingDraft(false)}
        threadId={email.thread_id}
        twinId={twinId}
        setThread={setThread}
        setVerboseOutput={setVerboseOutput}
      />
    </JelledModal>
  )
}

export default EnhanceDraftModal
